import { render } from "./UsersPresence.vue?vue&type=template&id=4d7f204f&scoped=true"
import script from "./UsersPresence.vue?vue&type=script&lang=js"
export * from "./UsersPresence.vue?vue&type=script&lang=js"

import "./UsersPresence.vue?vue&type=style&index=0&id=4d7f204f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7f204f"]])

export default __exports__